import { flex } from "./flex";
import { fonts } from "./fonts";
import { colors } from "./colors";

export const theme = { colors, fonts, flex };
